export const IDS = {
  AZURE_FORM: 'azureLoginForm',
  MODAL: 'loginModal',
  FORM: 'loginForm',
  MAIN_HEADER: 'mainHeaderLoginModal',
  MAIN_PARAGRAPH: 'mainParagraphLoginModal',
  USERNAME_INPUT: 'usernameInputLoginModal',
  PASSWORD_INPUT: 'passwordInputLoginModal',
  USERNAME_WRAPPER: 'usernameWrapperLoginModal',
  PASSWORD_WRAPPER: 'passwordWrapperLoginModal',
  USERNAME_LABEL: 'usernameLabelLoginModal',
  PASSWORD_LABEL: 'passwordLabelLoginModal',
  /* this submit is need to simulate submit of form with input and password */
  SUBMIT: 'loginFormSubmitLoginModal',
  FORGOT_PASSWORD_LINK: 'forgotPasswordLinkLoginModal',
  NOT_YET_REGISTERED_WRAPPER: 'notYetRegisteredWrapperLoginModal',
  NOT_YET_REGISTERED_LINK: 'notYetRegisteredLoginModal',
  BOTTOM_LINKS_HR: 'bottomLinksHrLoginModal',
  BANNER_IMG: 'bannerImgLoginModal',
  TEXT_SUBMIT_BUTTON: 'textSubmitButton',
  LOADING_ICON_SUBMIT_BUTTON: 'loadingIconSubmitButtonLoginModal',
  INFO_BANNER: 'infoBannerLoginModal',
  INCORRECT_CREDENTIALS_BANNER: 'incorrectCredentialsBanner',
  SESSION_EXPIRE_BANNER: 'sessionExpireBanner',
  CLOSE_BUTTON: 'closeButton',
};
